import styled from "styled-components";
import { theme } from "../../theme";
import { userManager } from "../../auth/oidcConfig";
import { useEffect, useState } from "react";
import Body from "../atoms/typography/Body";
import Subtitle from "../atoms/typography/Subtitle";
import Lookup from "../organisms/Lookup";
import { useNavigate } from "react-router-dom";

const StyledHeader = styled.div<{ prod: boolean }>`
  width: auto;
  padding: 1rem 2rem 1rem 2rem;
  background: ${(props) =>
    props.prod
      ? theme.colors.primary
      : "linear-gradient(262.62deg, #0C1040 0%, #74AAB8 100%)"};
  display: flex;
  justify-content: space-between;
  align-items: baseline;
`;

const Header: React.FC = () => {
  const [user, setUser] = useState<any>(null);
  const navigate = useNavigate();

  const getUser = async () => {
    await userManager.getUser().then((user) => {
      if (user) {
        setUser(user?.profile);
      }
    });
  };

  useEffect(() => {
    getUser();
  }, []);

  const isInProd = import.meta.env.VITE_ENVIRONMENT === "prod";

  const onClickItem = (item: {
    clientIdentifier: string;
    clientType: string;
    companyName: string;
  }) => {
    navigate(`/client/${item.clientIdentifier}`);
  };
  return (
    <StyledHeader prod={isInProd}>
      <Subtitle color={theme.colors.white}>Mainframe</Subtitle>
      <div style={{ display: "flex", gap: 32, alignItems: "center" }}>
        <Lookup
          type="dropdownSmall"
          onClickResult={onClickItem}
          variant="light"
        />
        {user && <Body color="white">{user.name}</Body>}
      </div>
    </StyledHeader>
  );
};

export default Header;
